export default {
  type: "object",
  properties: {
    used: {
      type: "integer",
      description: "currently in use",
      example: "1"
    },
    max: {
      type: "integer",
      description: "number of uses under license",
      example: "10"
    },
    percentage: {
      type: "number",
      description: "usage percentage",
      example: "10"
    }
  }
};
